import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { UiButton, UiGradiantOutlinedBtn } from "../common/UiButton";
import { UiHorizontalButtonGroup } from "../common/UiHorizontalButtonGroup";

export const ExpiryPopup = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className={
          props?.className ? props?.className : "df-confirmation-message-popup"
        }
      >
        {props?.icon}
        <h3 className="df-confirmation-message-popup__message">
          {props?.message}
        </h3>
        {props?.children}
        <UiHorizontalButtonGroup>
          <UiGradiantOutlinedBtn
            className="df-red-gradiant-outlined-btn"
            name={props?.cancelText}
            onClick={props?.cancelOnclick}
          />
          <UiButton
            className="df-ui-dark-bg-btn"
            name={props?.continueText}
            onClick={props?.successOnclick}
          />
        </UiHorizontalButtonGroup>
      </div>
    </>
  );
};
